export enum AgentsActionTypes {
  START_IMPERSONATION = '@@agents/START_IMPERSONATION',
  START_IMPERSONATION_SUCCESS = '@@agents/START_IMPERSONATION_SUCCESS',
  CANCEL_IMPERSONATION = '@@agents/CANCEL_IMPERSONATION',
  CANCEL_IMPERSONATION_SUCCESS = '@@agents/CANCEL_IMPERSONATION_SUCCESS',
}
